// extracted by mini-css-extract-plugin
module.exports = {"supplierCategory":"locations-list_supplierCategory__EJM3p","locationText":"locations-list_locationText__hnPnu"};